import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Row, Col, Button, ButtonToolbar } from 'react-bootstrap';
import gql from 'graphql-tag';

import ExcelOnlinePreview from './ExcelOnlinePreview';
import WindowPortal from '../WindowPortal';

class ExcelTicketSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSpreadsheetPortal: false,
    };

    this.openSpreadsheetPortal = this.openSpreadsheetPortal.bind(this);
    this.closeSpreadsheetPortal = this.closeSpreadsheetPortal.bind(this);
  }

  componentDidMount() {
    window.addEventListener('beforeunload', () => {
      this.closeSpreadsheetPortal();
    });
  }

  openSpreadsheetPortal() {
    this.setState({
      showSpreadsheetPortal: true,
    });
  }

  closeSpreadsheetPortal() {
    this.setState({
      showSpreadsheetPortal: false,
    });
  }

  renderItem(item, label) {
    return (
      <Col md={6}>
        <div className="form-group">
          <label className="control-label">{ label }</label>
          <input disabled className="form-control" value={item || 'unknown'} />
        </div>
      </Col>
    );
  }

  renderEquipment(equipment) {
    let eqString = null;

    if (equipment) {
      eqString = equipment.map((eq) => {
        return eq.number;
      }).join(', ');
    }

    return this.renderItem(eqString, 'Equipment');
  }

  renderSummary(summary) {
    let ticketSummary = summary;
    if (!ticketSummary) {
      ticketSummary = {};
    }

    const {
      date_str: dateStr,
      customer,
      excel_equipment: excelEquipment,
      job_type: jobType,
      well_name: wellName,
      customer_name: customerName,
      excel_ticket_number: ticketNumber,
      service_district: serviceDistrict,
      billing_revenue: billingRevenue,
    } = ticketSummary;

    return (
      <div>
        <Row>
          { this.renderItem(dateStr, 'Date') }
          { this.renderItem(jobType, 'Job Type') }
        </Row>
        <Row>
          { this.renderItem(serviceDistrict, 'Service District') }
          { this.renderEquipment(excelEquipment) }
        </Row>
        <Row>
          { this.renderItem(ticketNumber, 'Ticket Number') }
          { this.renderItem(customer, 'Customer') }
        </Row>
        <Row>
          { this.renderItem(customerName, 'Customer Name') }
          { this.renderItem(wellName, 'Well Name') }
        </Row>
        <Row>
          { this.renderItem(billingRevenue, 'Net Revenue')}
        </Row>
      </div>
    );
  }

  renderSpreadsheetButton(shown) {
    const actionFunc = shown ? this.closeSpreadsheetPortal : this.openSpreadsheetPortal;
    const actionMsg = shown ? 'Close' : 'Preview';

    return (
      <div>
        <ButtonToolbar className="pull-right">
          <Button
            className="btn pull-right"
            bsStyle="warning"
            onClick={actionFunc}
          >
            { actionMsg } Spreadsheet
          </Button>
        </ButtonToolbar>
      </div>
    );
  }

  renderSpreadsheetPortal(fileUrl) {
    // These dimensions were chosen because they looked the best at the time.
    // Feel free to tweak as needed
    const width = 1200;
    const height = 1000;
    return (
      <WindowPortal
        title="Spreadsheet"
        width={width}
        height={height}
        closeWindowPortal={this.closeSpreadsheetPortal}
      >
        <ExcelOnlinePreview
          fileUrl={this.props.fileUrl}
        />
      </WindowPortal>
    );
  }

  render() {
    const { excel_ticket_summary: summary } = this.props;

    return (
      <div>
        { this.renderSummary(summary) }
        { this.renderSpreadsheetButton(this.state.showSpreadsheetPortal) }
        { this.state.showSpreadsheetPortal && this.renderSpreadsheetPortal(this.props.fileUrl)}
      </div>
    );
  }
}

ExcelTicketSummary.defaultProps = {
  excel_ticket_summary: {},
};

ExcelTicketSummary.propTypes = exact({
  fileUrl: PropTypes.string.isRequired,
  excel_ticket_summary: PropTypes.shape({
    customer: PropTypes.string,
    customer_name: PropTypes.string,
    date: PropTypes.object,
    date_str: PropTypes.string,
    job_type: PropTypes.string,
    service_district: PropTypes.string,
    excel_ticket_number: PropTypes.string,
    well_name: PropTypes.string,
    excel_equipment: PropTypes.arrayOf(PropTypes.shape({
      number: PropTypes.string,
      driver: PropTypes.string,
    })),
  }),
});

ExcelTicketSummary.fragment = gql`
  fragment Summary on ExcelTicketSummary {
    customer
    customer_name
    date {
      display
    }
    date_str
    job_type
    service_district
    excel_ticket_number
    billing_revenue
    well_name
    excel_equipment {
      driver
      number
    }
  }
`;

export default ExcelTicketSummary;
